import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Flex, Link, Text } from '@siteground/styleguide';
import { ROUTES } from '../../../../constants/routes';

const OperatorInfoFooter = () => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <Flex align="center" justify="center" style={{ width: '100%' }}>
      <Text size="small">
        <FormattedMessage
          id="translate.operator.info.footer.message"
          values={{
            link: (
              <Link onClick={() => history.push(ROUTES.OPERATOR_FEEDBACK)}>
                {intl.formatMessage({ id: 'translate.operator.info.footer.message.link' })}
              </Link>
            )
          }}
        />
      </Text>
    </Flex>
  );
};

export default OperatorInfoFooter;
